<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17 2C17.5523 2 18 2.44772 18 3V4H19C20.6569 4 22 5.34315 22 7V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V7C20 6.44772 19.5523 6 19 6H18V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7V6H8V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V6H5C4.44772 6 4 6.44772 4 7V10H9C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H4V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H5C3.34315 22 2 20.6569 2 19V7C2 5.34315 3.34315 4 5 4H6V3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3V4H16V3C16 2.44772 16.4477 2 17 2ZM18.6129 12.2097L18.7071 12.2929L21.7071 15.2929C22.0676 15.6534 22.0953 16.2206 21.7903 16.6129L21.7071 16.7071L16.7071 21.7071C16.5508 21.8634 16.3481 21.9626 16.1314 21.9913L16 22H13C12.4872 22 12.0645 21.614 12.0067 21.1166L12 21V18C12 17.779 12.0732 17.5655 12.2061 17.392L12.2929 17.2929L17.2929 12.2929C17.6534 11.9324 18.2206 11.9047 18.6129 12.2097ZM18 14.4142L14 18.4142V20H15.5858L19.5858 16L18 14.4142Z"
    fill="currentColor"
  />
</svg>
